// extracted by mini-css-extract-plugin
export var layoutContainer = "_d9-0";
export var layoutContainerNoRounding = "_d9-6";
export var layoutContainerOpen = "_d9-5";
export var layoutContainerResizing = "_d9-1";
export var mainContent = "_d9-2";
export var resizeDivider = "_d9-3";
export var slidePanel = "_d9-4";